export var hintMotion = {
  initial: {
    opacity: 0,
    right: -10
  },
  animate: {
    opacity: 1,
    right: 0
  },
  exit: {
    opacity: 0
  }
};